/**
 * Authentication not authenticated component
 * Displays message when user is not authenticated with link to external auth page
 */

import { Button } from "@/shared/ui/button"
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/shared/ui/card"
import { cn } from "@/shared/ui/lib"

export interface AuthNotAuthenticatedProps {
	/** Message to display */
	title: string
	message: string
	/** External authorization URL */
	authUrl: string
	/** Button text */
	buttonText: string
	className?: string
}

/**
 * Component that displays message when user is not authenticated
 * Provides link to external authorization page
 */
export function AuthNotAuthenticated({
	title,
	message,
	authUrl,
	buttonText,
	className,
}: AuthNotAuthenticatedProps) {
	const handleAuthClick = () => {
		if (typeof window !== "undefined" && authUrl) {
			window.location.href = authUrl
		}
	}

	return (
		<div
			className={cn(
				"min-h-screen flex items-center justify-center bg-background p-4",
				className,
			)}
		>
			<Card className="w-full max-w-md">
				<CardHeader>
					<CardTitle>{title}</CardTitle>
					<CardDescription>{message}</CardDescription>
				</CardHeader>
				<CardContent>
					<Button
						onClick={handleAuthClick}
						variant="default"
						className="w-full"
						disabled={!authUrl}
					>
						{buttonText}
					</Button>
				</CardContent>
			</Card>
		</div>
	)
}
